import React, { CSSProperties } from 'react'
import { useDetailTheme } from '../../DetailContext'
import './DetailText.css'

const DetailText = ({ 
    children, 
    type, 
    textSize = 12, 
    textAlign, 
    textWeight, 
    customColor,
    style
}: { 
    children: string | number | (string | number)[], 
    type?: "bold" | "normal", 
    textSize?: number, 
    textAlign?: CSSProperties["textAlign"], 
    textWeight?: number, 
    customColor?: string 
    style?: CSSProperties
}) => {
    const { color } = useDetailTheme()

    return (
        <span style={{ fontSize: textSize, color: customColor || color, textAlign, fontWeight: textWeight, ...style }} className={type === "bold" ? "drawer-detail__text drawer-detail__text__bold" : "drawer-detail__text drawer-detail__text__normal"}>{children}</span>
    )
}

export default DetailText
